module.exports = __webpack_public_path__ + "static/media/md-fastforward.4b948df7.svg";